export default "__VITE_ASSET__DxIeK4Qa__"